import {
    CrudFilters,
    IResourceComponentsProps, useCreate,
    useExport,
    useGetIdentity,
    useList,
    useNotification,
    useTranslate,
    useUpdate,
} from '@refinedev/core';

import {
    DateField,
    DeleteButton,
    List,
    ShowButton,
    TagField,
    useForm,
    useModal,
    useTable,
} from "@refinedev/antd";

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import {
    Button,
    Col,
    Divider,
    Form, Input,
    InputNumber, InputRef,
    MenuProps, message,
    Modal,
    Popconfirm, Popover,
    Row, Select,
    Space,
    Spin, Statistic,
    Table,
    Tooltip,
    Typography, Upload, UploadProps,
} from 'antd';

import React, {useContext, useEffect, useRef, useState} from 'react';
import {IAlertRestock, ICausal, IDocument, ISaleMovement, IStock, ITurn, ITurnCost} from '../../interfaces';
import {StoreContext} from '../../contexts/StoreContext';
import dayjs from 'dayjs';
import "./style.css";
import {CSVLink} from 'react-csv';
import { useLocation, useNavigate } from "react-router-dom";
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import PizZipUtils from 'pizzip/utils/index.js';
import { saveAs } from 'file-saver';
import {API_URL} from '../../constants';
import {ColumnType} from 'antd/es/table';
import {FilterConfirmProps} from 'antd/es/table/interface';
const { Title } = Typography;
const { Dragger } = Upload;

function loadFile(url: any, callback: any) {
    PizZipUtils.getBinaryContent(url, callback);
}
export const TurnList: React.FC<IResourceComponentsProps> = () => {
    const translate = useTranslate();
    const state: any = useLocation();
    const {value, value2} = useContext(StoreContext);
    const [store, setStore] = value;
    const { data: userIdentity } = useGetIdentity<any>();
    const {tableProps, searchFormProps, tableQuery} = useTable<ITurn>({
        resource: "turns",
        meta: {populate: '*'},

        pagination: {
            pageSize: 15,
            mode: 'server'
        },
        onSearch: (params: any) => {
            const filters: CrudFilters = [];

            filters.push(
                {
                    operator: "or",
                    value: [
                        {
                            field: "product][barcodes][code]",
                            operator: "eq",
                            value: (params?.description) ? params?.description : ''
                        },
                        {
                            field: "product][barcode_packages][code]",
                            operator: "eq",
                            value: (params?.description) ? params?.description : ''
                        },
                        {
                            field: "product][description]",
                            operator: "contains",
                            value: (params?.description) ? params?.description : ''
                        },
                        {
                            field: "product][codice]",
                            operator: "contains",
                            value: (params?.description) ? params?.description : ''
                        },
                        {
                            field: "product][category][description]",
                            operator: "contains",
                            value: (params?.description) ? params?.description : ''
                        },
                    ]
                },
                {
                    field: "product][category][id]",
                    operator: "contains",
                    value: (params?.category) ? params?.category : ''
                }
            );

            return filters;
        },
        filters: {
            permanent: [
                {
                    field: "seller][id]",
                    operator: 'eq',
                    value: store?.id
                }
            ]
        },

        sorters: {
            permanent: [
                {
                    field: 'createdAt',
                    order: 'desc'
                }
            ]
        }
    });

    const [causaliArrayUscite, setCausaliArrayUscite] = useState<any[]>([]);
    const [causaliArrayEntrate, setCausaliArrayEntrate] = useState<any[]>([]);
    const { show, close, modalProps } = useModal();
    const [turn, setTurn] = useState<ITurn>();
    const [causali, setCausali] = useState<any>();
    const tabacchi = useRef(0);
    const accessori= useRef(0);
    const [detailCategory, setDetailCategory] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [incassoReale, setIncassoReale] = useState<any>(0);
    const [importoEntrate, setImportoEntrate] = useState<any>(0);
    const [importoEntrateCausali, setImportoEntrateCausali] = useState<any>(0);
    const [importoUscite, setImportoUscite] = useState<number>(0);
    const gratta = useRef(0);
    const scontrinato = useRef(0);
    const scontrinato22 = useRef(0);

    const getAlertRestock = useList<IAlertRestock>({
        resource: 'alert-restocks',

        meta: {
            populate: "seller, turn, stock, stock.product, stock.product.category, turn.user"
        },

        queryOptions: {
            enabled: false
        },

        pagination: {
            pageSize: 100000000,
        },

        filters: [
            {
                field: "seller][id]",
                operator: 'eq',
                value: store?.id
            },
            {
                field: "turn][id]",
                operator: 'eq',
                value: turn?.id
            },
            {
                field: "isAlert",
                operator: 'eq',
                value: true
            }
        ],

        sorters: [
            {
                field: 'id',
                order: 'desc'
            }
        ]
    });

    const getCausali = useList<ICausal>({
        resource: 'causals',

        meta: {
            populate: '*'
        },
        pagination: {
            pageSize: 999,
        },
        queryOptions: {
            enabled: false
        },

        filters: [
            {
                field: "seller][id]",
                operator: 'eq',
                value: store?.id
            },
            {
                field: "isTurn",
                operator: 'eq',
                value: true
            }
        ],
        sorters: [
            {
                field: 'ordinamento',
                order: 'asc'
            }
        ]
    });

    const getDocumenti = useList<IDocument>({
        resource: 'documents',

        meta: {
            populate: '*'
        },
        pagination: {
            pageSize: 999,
        },
        queryOptions: {
            enabled: false
        },

        filters: [
            {
                field: "seller][id]",
                operator: 'eq',
                value: store?.id
            },
            {
                field: "turn][id]",
                operator: 'eq',
                value: turn?.id
            }
        ]
    });

    const [giacenzaT, setGiacenzaT] = useState<any>();
    const [giacenzaG, setGiacenzaG] = useState<any>();
    const [giacenzaA, setGiacenzaA] = useState<any>();
    const showDetail = (record: any) => {
        // console.log(record);
        setGiacenzaT(record.giacenzaT);
        setGiacenzaG(record.giacenzaG);
        setGiacenzaA(record.giacenzaA);
        setExportDataTurn((current: any) => [...current, record]);
        setLoading(true);
        if (record && record.dati && record.dati.exit && Object.keys(record.dati.exit).length > 0) {
            for (let o of Object.keys(record.dati.exit)) {
                // console.log(o);
                uscite.setFieldValue(o, record.dati.exit[o])
            }
        } else {
            uscite.resetFields();
        }
        if (record && record.dati && record.dati.entrate && Object.keys(record.dati.entrate).length > 0) {
            for (let o of Object.keys(record.dati.entrate)) {
                // console.log(o);
                entrate.setFieldValue(o, record.dati.entrate[o])
            }
        } else {
            entrate.resetFields();
        }
        if (record && record.dati && record.dati.in && Object.keys(record.dati.in).length > 0) {
            // setScontrinato22(record.dati.in.scontrinato22);
            scontrinato22.current = record.dati.in.scontrinato22;
            // setScontrinato(record.dati.in.scontrinato);
            scontrinato.current = record.dati.in.scontrinato;
            setIncassoReale(record.dati.incassoReale);
            // setTabacchi(record.dati.in.tabacchi);
            tabacchi.current = record.dati.in.tabacchi;
            // setGratta(record.dati.in.gev);
            gratta.current = record.dati.in.gev;
            // setAccessori(record.dati.in.acs);
            accessori.current = record.dati.in.acs;
        }
        setTurn(record);
        setTimeout(() => {
            const cauUscite: any = [];
            const cauEntrate: any = [];
            getCausali.refetch().then( causal => {
                causal.data?.data.map( c => {
                    if (c.isUnLoad) {
                        // console.log('UNLOAD')
                        cauUscite.push({
                            id: c.acronimo,
                            amount: uscite.getFieldValue(c.acronimo) ? uscite.getFieldValue(c.acronimo) : 0,
                            isUnLoad: true,
                            isLoad: false
                        })
                    }
                    if (c.isLoad) {
                        // console.log('LOAD')
                        cauEntrate.push({
                            id: c.acronimo,
                            amount: entrate.getFieldValue(c.acronimo) ? entrate.getFieldValue(c.acronimo) : 0,
                            isLoad: true,
                            isUnLoad: false
                        })
                    }

                })
                setCausaliArrayUscite([...cauUscite]);
                // setCausaliArrayEntrate([...cauEntrate]);
                // console.log(cau)
                setCausali(causal.data?.data);
                // console.log(causaliArray)
                setTimeout(() => {
                    // console.log(tabacchi);
                    // console.log(causali);
                    setImportoEntrate(Number(parseFloat(tabacchi.current.toString()) + parseFloat(gratta.current.toString()) + parseFloat(scontrinato.current.toString()) + parseFloat(scontrinato22.current.toString()) + parseFloat(accessori.current.toString()) + parseFloat(importoEntrateCausali.toString())).toFixed(2));
                    setLoading(false);
                }, 700)
            })
            show();
        }, 500)
        setLoading(false);

    }

    const onChangeTabacchi = (e: any) => {
        // setTabacchi(e);
        tabacchi.current = e;
        setImportoEntrate(Number(parseFloat(tabacchi.current.toString()) + parseFloat(gratta.current.toString()) + parseFloat(scontrinato.current.toString()) + parseFloat(scontrinato22.current.toString()) + parseFloat(accessori.current.toString())).toFixed(2));
    }

    const onChangeAccessori = (e: any) => {
        // setAccessori(e);
        accessori.current = e;
        setImportoEntrate(Number(parseFloat(tabacchi.current.toString()) + parseFloat(gratta.current.toString()) + parseFloat(scontrinato.current.toString()) + parseFloat(scontrinato22.current.toString()) + parseFloat(accessori.current.toString())).toFixed(2));

    }

    const onChangeGratta = (e: any) => {
        // setGratta(e);
        gratta.current = e;
        setImportoEntrate(Number(parseFloat(tabacchi.current.toString()) + parseFloat(gratta.current.toString()) + parseFloat(scontrinato.current.toString()) + parseFloat(scontrinato22.current.toString()) + parseFloat(accessori.current.toString())).toFixed(2));

    }

    const onChangeScontrinato = (e: any) => {
        // setScontrinato(e);
        scontrinato.current = e;
        setImportoEntrate(Number(parseFloat(tabacchi.current.toString()) + parseFloat(gratta.current.toString()) + parseFloat(scontrinato.current.toString()) + parseFloat(scontrinato22.current.toString()) + parseFloat(accessori.current.toString())).toFixed(2));

    }

    const onChangeScontrinato22 = (e: any) => {
        // setScontrinato22(e);
        scontrinato22.current = e;
        setImportoEntrate(Number(parseFloat(tabacchi.current.toString()) + parseFloat(gratta.current.toString()) + parseFloat(scontrinato.current.toString()) + parseFloat(scontrinato22.current.toString()) + parseFloat(accessori.current.toString())).toFixed(2));

    }

    const onChangeIncassoReale = (e: any) => {
        // console.log(e);
        setIncassoReale(Number(parseFloat(e.toString())));
    }

    const onChangeUscite = (e: any, acronimo: any) => {
        // console.log(e, incassoReale);
        const index = causaliArrayUscite.findIndex((x: any) => x.id === acronimo);
        causaliArrayUscite[index]['amount'] = e;
        // console.log(causaliArray[0]);
        setImportoUscite(causaliArrayUscite.reduce((sum: any, currentValue: any) => { return sum + parseFloat(currentValue.amount) }, 0));
        // console.log(importoUscite)
    }

    const onChangeEntrate = (e: any, acronimo: any) => {
        console.log(e, 'ENTRATE');
        const index = causaliArrayEntrate.findIndex((x: any) => x.id === acronimo);
        causaliArrayEntrate[index]['amount'] = e;
        // console.log(causaliArray[0]);
        setImportoEntrateCausali(causaliArrayEntrate.reduce((sum: any, currentValue: any) => { return sum + parseFloat(currentValue.amount) }, 0));
        // console.log(importoUscite)
    }

    useEffect(() => {
        if (causaliArrayUscite && causaliArrayUscite.length > 0) {
            setImportoUscite(causaliArrayUscite.reduce((sum: any, currentValue: any) => { return (currentValue.isUnLoad) ? sum + parseFloat(currentValue.amount) : 0}, 0));

        }
        if (causaliArrayEntrate && causaliArrayEntrate.length > 0) {
            setImportoEntrateCausali(causaliArrayEntrate.reduce((sum: any, currentValue: any) => { return (currentValue.isLoad) ? sum + parseFloat(currentValue.amount) : 0}, 0));

        }
        // setImportoEntrate(Number(parseFloat(tabacchi.current.toString()) + parseFloat(gratta.current.toString()) + parseFloat(scontrinato.current.toString()) + parseFloat(scontrinato22.current.toString())));
        // console.log(tabacchi.current);
        // console.log(gratta.current);
        // console.log(accessori.current);
        // console.log(turn);
        // console.log(importoEntrate)
    });

    useEffect(() => {
        // if (state && state?.state?.isOpen) {
        //     showDetail(state?.state?.record);
        // }
        // console.log(tableQuery)
        if (tableQuery && tableQuery.data && tableQuery.data?.data.length > 0) {
            for (let turno of tableQuery.data?.data) {
                // console.log(turno);
                if (!turno.isConfirmed && turno.dataOut) {
                    console.log('XXX VISUALIZZO TURNO')
                    showDetail(turno);
                }
            }
        }
    }, [tableQuery.isFetched])

    const [exportDataDeleteMovement, setExportDataDeleteMovement] = useState([]);
    const [exportDataRestock, setExportDataRestock] = useState([]);
    const [exportDataTurn, setExportDataTurn] = useState<any>([]);
    const { show: showDetailMovement, close: closeDetailMovement, modalProps: modalDetailMovement } = useModal();
    const { show: showModalDeletedMovement, close: closeModalDeletedMovement, modalProps: modalDeletedMovement } = useModal();
    const { show: showModalAlertRestock, close: closeModalAlertRestock, modalProps: modalAlertRestock } = useModal();
    const { show: showModalSnapshotStock, close: closeModalSnapshotStock, modalProps: modalModalSnapshotStock } = useModal();
    const { show: showModalDocument, close: closeModalDocument, modalProps: modalModalDocument } = useModal();
    const { show: showModalDocumentT, close: closeModalDocumentT, modalProps: modalModalDocumentT } = useModal();
    const { show: showModalDocumentG, close: closeModalDocumentG, modalProps: modalModalDocumentG } = useModal();
    const { show: showModalDocumentA, close: closeModalDocumentA, modalProps: modalModalDocumentA } = useModal();


    const [valoreRiassortimento, setValoreRiassortimento] = useState<any>();

    function getAlertRestocks(): Promise<any> {
        return new Promise( resolve => {
            getAlertRestock.refetch().then( (res: any) => {
                // console.log("DATA ALERT RESTOCK: ", res);
                console.log(res.data?.data);
                res.data?.data.reduce((acc: any, item: any) => {
                    const product = item.stock.product;

                    // valore: quantità * prezzo unitario
                    const valore = (item.qta || 0) * (product.price || 0);

                    if (product.isTabacco) {
                        acc.tabacco += valore;
                    } else if (product.isGeneric) {
                        acc.generic += valore;
                    } else if (product.isAccessory) {
                        acc.accessory += valore;
                    }

                    setValoreRiassortimento(acc);
                }, { tabacco: 0, generic: 0, accessory: 0 });
                resolve(res.data?.data);
            });
        })

    }

    const [loadingT, setLoadingT] = useState(false);
    const [loadingG, setLoadingG] = useState(false);
    const [loadingA, setLoadingA] = useState(false);
    const [loadingD, setLoadingD] = useState(false);
    const [loadingR, setLoadingR] = useState(false);
    const [loadingS, setLoadingS] = useState(false);
    const [loadingF, setLoadingF] = useState(false);
    const showMovementT = (record: any) => {
        setTurn(record);
        // setLoadingT(true);
        showModalDocumentT();

    }

    const showMovementG = (record: any) => {
        setTurn(record);
        // setLoadingG(true);
        showModalDocumentG();

    }

    const showMovementA = (record: any) => {
        setTurn(record);
        // setLoadingA(true);
        showModalDocumentA();

    }

    const showDeletedMovement = (record: any) => {
        setTurn(record);
        setLoadingD(true);
    }

    const showAlertRestock = (record: any) => {
        setTurn(record);
        setLoadingR(true);
        setTimeout(() => {
            getAlertRestocks().then( (res: any) => {
                setExportDataRestock(res);
                setTimeout(() => {
                    setLoadingR(false);
                    showModalAlertRestock();
                }, 400)
            });
        }, 500)
    }

    const showSnapshotStock = (record: any) => {
        setTurn(record);
        setLoadingS(true);
        setTimeout(() => {
                    setLoadingS(false);
                    showModalSnapshotStock();
        }, 500)
    }

    const showDocument = (record: any) => {
        setTurn(record);
        setLoadingF(true);
        setTimeout(() => {
            getDocumenti.refetch().then((res: any) => {
                // console.log(res);
            })
            setLoadingF(false);
            showModalDocument();
        }, 500)
    }

    const exportTurn = () => {
        // console.log("EXPORT: ", turn);
        // console.log("CAUSALI: ", causali);
        // console.log("CATEGORY: ", detailCategory);
        const dati: any = turn?.dati;
        const entrate: any = [];
        const uscite: any = [];
        for (let ent of dati.detailCategory) {
            entrate.push({
                descrizione: ent.category,
                importo: Number(ent.tot).toFixed(2)
            })
        }
        // for (let ent of Object.keys(dati.entrate)) {
        //     entrate.push({
        //         descrizione: causali.find((x: any) => x.acronimo === ent).description,
        //         importo: Number(dati.entrate[ent]).toFixed(2)
        //     })
        // }
        entrate.push(
            {
                descrizione: 'Tabacchi',
                importo: Number(dati.in['tabacchi']).toFixed(2)
            },
            {
                descrizione: 'Gratta & Vinci',
                importo: Number(dati.in['gev']).toFixed(2)
            },
            {
                descrizione: 'Accessori',
                importo: Number(dati.in['acs']).toFixed(2)
            },
            {
                descrizione: 'Scontrinato',
                importo: Number(dati.in['scontrinato']).toFixed(2)
            },
            {
                descrizione: 'Scontrinato 22%',
                importo: Number(dati.in['scontrinato22']).toFixed(2)
            })
        for (let ent of Object.keys(dati.exit)) {
            uscite.push({
                descrizione: causali.find((x: any) => x.acronimo === ent).description,
                importo: Number(dati.exit[ent]).toFixed(2)
            })
        }
        // console.log(entrate);
        // console.log(uscite);
        loadFile(
            '/template/TURN.docx',
            function (error: any, content: any) {
                if (error) {
                    throw error;
                }
                const zip = new PizZip(content);
                const doc = new Docxtemplater(zip, {
                    paragraphLoop: true,
                    linebreaks: true,
                });
                        doc.setData({
                            dataIn: dayjs(turn?.dataIn).format('DD-MM-YYYY HH:mm'),
                            dataOut: dayjs(turn?.dataOut).format('DD-MM-YYYY HH:mm'),
                            user: turn?.user?.name + ' ' + turn?.user?.name,
                            isDeleted: (exportDataDeleteMovement && exportDataDeleteMovement?.length > 0) ? 'Sono Presenti Movimenti Cancellati' : 'NO',
                            isRestock: (exportDataRestock && exportDataRestock?.length > 0) ? 'Sono Presenti Riassortimenti' : 'NO',
                            in: entrate,
                            exit: uscite,
                            importoEntrate: Number(dati.importoEntrate).toFixed(2),
                            importoUscite: Number(dati.importoUscite).toFixed(2),
                            incassoContabile: Number(dati.incassoContabile).toFixed(2),
                            incassoReale: Number(dati.incassoReale).toFixed(2),
                            differenza: Number(dati.differenza).toFixed(2)
                        });
                        try {
                            doc.render();
                        } catch (error) {
                            throw error;
                        }
                        let out = doc.getZip().generate({
                            type: 'blob',
                            mimeType:
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        }); //Output the document using Data-URI
                        saveAs(out, 'TURNO_' + dayjs(turn?.dataIn).format('DD_MM_YYYY') + '.docx');
            }
        );
    }

    const {open} = useNotification();
    const {form: uscite} = useForm();
    const {form: entrate} = useForm();
    const updateTurn = useUpdate<ITurn>();
    const [openConfirm, setOpenConfirm] = useState(false);
    const showPopconfirm = () => {
        setOpenConfirm(true);
    };
    const handleCancel = () => {
        // console.log('Clicked cancel button');
        setOpenConfirm(false);
        window.location.reload();
    };

    const onCheck = async () => {
        try {
            // const values = await form.validateFields();
            // console.log('Success:', values);
            // console.log("scontrinato: ", scontrinato);
            // console.log("scontrinato22: ", scontrinato22);
            console.log("incasso reale: ", incassoReale);
            if (tabacchi.current && accessori.current && gratta.current && scontrinato22.current && scontrinato.current && (incassoReale >= 0)) {
                showPopconfirm();
            } else {
                open?.({
                    type: 'error',
                    message: 'Devi compilare necessariamente tutti i campi...',
                    description: 'Attenzione!',
                });
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };

        const conferma = () => {
                setOpenConfirm(false);
                // console.log(form.getFieldsValue());
            console.log(turn);
            console.log('RIASSORTIMENTO T: ', turn?.valoreRiassortimentoT);
            console.log('RIASSORTIMENTO G: ', turn?.valoreRiassortimentoG);
            console.log('RIASSORTIMENTO A: ', turn?.valoreRiassortimentoA);
            const valoreFinaleT: any = ((Number(parseFloat(giacenzaT.toString())) + Number(turn?.valoreRiassortimentoT)) - Number(parseFloat(tabacchi.current.toString()))).toFixed(2);
            const valoreFinaleG: any = ((Number(parseFloat(giacenzaG.toString())) + Number(turn?.valoreRiassortimentoG)) - Number(parseFloat(gratta.current.toString()))).toFixed(2);
            const valoreFinaleA: any = ((Number(parseFloat(giacenzaA.toString())) + Number(turn?.valoreRiassortimentoA)) - Number(parseFloat(accessori.current.toString()))).toFixed(2);
            console.log((valoreFinaleA + valoreFinaleG + valoreFinaleT) < (Number(turn?.giacenzaT) + Number(turn?.giacenzaA) + Number(turn?.giacenzaG)));
            console.log((Number(valoreFinaleA) + Number(valoreFinaleG) + Number(valoreFinaleT)))
            console.log((Number(turn?.giacenzaT) + Number(turn?.giacenzaA) + Number(turn?.giacenzaG)))

            updateTurn.mutateAsync({
                resource: 'turns',
                successNotification: false,
                id: Number(turn?.id),
                values: {
                    isConfirmed: true,
                    valoreFinaleT: valoreFinaleT,
                    valoreFinaleG: valoreFinaleG,
                    valoreFinaleA: valoreFinaleA,
                    dati: {
                        detailCategory,
                        in: {
                            tabacchi: Number(parseFloat(tabacchi.current.toString())).toFixed(2),
                            gev: Number(parseFloat(gratta.current.toString())).toFixed(2),
                            acs: Number(parseFloat(accessori.current.toString())).toFixed(2),
                            scontrinato: Number(parseFloat(scontrinato.current.toString())).toFixed(2),
                            scontrinato22: Number(parseFloat(scontrinato22.current.toString())).toFixed(2),
                        },
                        entrate: entrate.getFieldsValue(),
                        incassoReale: Number(parseFloat(incassoReale.toString())).toFixed(2),
                        importoEntrate: Number(parseFloat(importoEntrate.toString())).toFixed(2),
                        importoUscite: Number(parseFloat(importoUscite.toString())).toFixed(2),
                        incassoContabile: Number(parseFloat(importoEntrate) - importoUscite).toFixed(2),
                        differenza: Number(incassoReale - (importoEntrate - importoUscite)).toFixed(2),
                        isRestock: (exportDataRestock?.length > 0) ? 'SI' : 'NO',
                        isDeleted: (exportDataDeleteMovement?.length > 0)? 'SI' : 'NO',
                        exit: uscite.getFieldsValue()
                    }
                }
            }).then( r => {
                if (tableQuery && tableQuery.data && tableQuery.data?.data.length > 0) {
                    for (let turno of tableQuery.data?.data) {
                        if (!turno.dataOut) {
                            // eseguo update valore Finale
                            updateTurn.mutateAsync({
                                resource: 'turns',
                                successNotification: false,
                                id: Number(turno.id),
                                values: {
                                    giacenzaT: valoreFinaleT,
                                    giacenzaG: valoreFinaleG,
                                    giacenzaA: valoreFinaleA,
                                }
                            }).then(() => {
                                close();
                                open?.({
                                    type: 'success',
                                    message: 'Modulo Chiuso Correttamente...',
                                    description: 'Info!',
                                });
                                setTimeout(() => {
                                    window.location.reload();
                                }, 500)
                            })
                        }
                    }
                }
            })

            if ((valoreFinaleA + valoreFinaleG + valoreFinaleT) < (Number(turn?.giacenzaT) + Number(turn?.giacenzaA) + Number(turn?.giacenzaG))) {
                console.log("Turno Chiuso Correttamente");
            } else {
                let alertMessage = "";
                if (valoreFinaleT >= Number(turn?.inventarioT)) {
                    alertMessage = 'Fare Inventario Espositore Tabacchi';
                } else if (valoreFinaleG >= Number(turn?.inventarioG)) {
                    alertMessage = 'Fare Inventario Espositore "G&V"';
                } else if (valoreFinaleA >= Number(turn?.inventarioA)) {
                    alertMessage = 'Fare Inventario Espositore Accessori';
                } else {
                    alertMessage = "Controllare le giacenze degli espositori";
                }
                open?.({
                    type: "error",
                    message: alertMessage,
                    description: "Attenzione!",
                });
            }

    }

    const createDocumento = useCreate<IDocument>();
    const props: UploadProps = {
        name: 'files',
        multiple: true,
        action: API_URL + '/api/upload',
        onChange(info) {
            // console.log(info.file.response);
            const { status } = info.file;
            if (status !== 'uploading') {
                // formProps.form?.setFieldValue("document", info.file.response);
            }
            if (status === 'done') {
                createDocumento.mutateAsync({
                    resource: 'documents',
                    values: {
                        description: info.file.response[0].name,
                        file: info.file.response[0].id,
                        seller: store.id,
                        turn: turn?.id,
                        user: userIdentity.id
                    }
                }).then(r => {
                    getDocumenti.refetch();
                    message.loading(`${info.file.name} file uploaded successfully.`);
                })
            } else if (status === 'error') {
                message.loading(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };
    // console.log(exportDataMovement);
    // console.log(exportDataRestock);
    // console.log(exportDataDeleteMovement);

    return (
        <List
            title={translate('pages.turn.title', 'Turni')}
            headerProps={{extra: []}
            }
        >
            <Table size="small" {...tableProps} rowKey="id"
                   onRow={(record) => {
                       return {
                           onClick: () => {
                               // console.log("turn", record);
                           },
                       };
                   }}
                   sticky={true}
                   // scroll={{y: window.innerHeight - 293 + 'px'}}
                   rowClassName={(record, index) => ((record.isConfirmed && record.isInventario) ? "bluLight" : record.isConfirmed ? "green" : "red")}
            >
                {/*<Table.Column dataIndex="id" key="id" title="ID"/>*/}
                <Table.Column
                    dataIndex="user"
                    key="user"
                    title={translate('pages.category.user', 'Utente')}
                    responsive={['xs', 'md', 'lg', 'xl']}
                    render={(value, record) => {
                        // <TagField value={value.name + ' ' + value.surname} />
                        return (<>
                            <TagField value={value?.name + ' ' + value?.surname} />
                        </>)
                    }
                }
                />
                <Table.Column
                    dataIndex="dataIn"
                    key="dataIn"
                    title={translate('pages.category.dataIn', 'Data Apertura')}
                    responsive={['md', 'lg', 'xl']}
                    render={(value) => <DateField value={value} format={'DD-MM-YYYY HH:mm'} />}
                />
                <Table.Column
                    dataIndex="dataOut"
                    key="dataOut"
                    title={translate('pages.category.dataOut', 'Data Chiusura')}
                    responsive={['md', 'lg', 'xl']}
                    render={(value) => <DateField value={value} format={'DD-MM-YYYY HH:mm'} />}
                />
                <Table.Column<{ id: string }>
                    title={translate('pages.docType.action', 'Azioni')}
                    dataIndex="actions"
                    responsive={['md', 'lg', 'xl']}
                    key="actions"
                    render={(_, record: any) => (
                        <Space>
                            <Tooltip placement="top" title={'Riepilogo Turno'}>
                            <ShowButton
                                hideText
                                size="small"
                                recordItemId={record.id}
                                disabled={!record.dataOut}
                                onClick={() => showDetail(record)}
                            />
                            </Tooltip>
                            <Tooltip placement="top" title={'Giacenza Espositore Tabacchi'}>
                            <Button
                                loading={loadingT && (turn?.id === Number(record.id))}
                                size={'small'}
                                style={{
                                    backgroundColor: (Number((record as any)?.valoreFinaleT ?? 0) > Number((record as any)?.inventarioT ?? 0)) ? 'red' : ''
                                }}
                                disabled={!record.dataOut}
                                icon={<Icons.TabletOutlined />}
                                danger={Number((record as any)?.valoreFinaleT ?? 0) > Number((record as any)?.inventarioT ?? 0)}
                                onClick={() => showMovementT(record)}
                            >
                            </Button>
                            </Tooltip>
                            <Tooltip placement="top" title={'Giacenza Espositore G&V'}>
                            <Button
                                loading={loadingG && (turn?.id === Number(record.id))}
                                size={'small'}
                                style={{
                                    backgroundColor: (Number((record as any)?.valoreFinaleG ?? 0) > Number((record as any)?.inventarioG ?? 0)) ? 'red' : ''
                                }}
                                disabled={!record.dataOut}
                                icon={<Icons.TabletOutlined />}
                                danger={Number((record as any)?.valoreFinaleG ?? 0) > Number((record as any)?.inventarioG ?? 0)}
                                onClick={() => showMovementG(record)}
                            >
                            </Button>
                            </Tooltip>
                            <Tooltip placement="top" title={'Giacenza Espositore Accessori'}>
                                <Button
                                    loading={loadingA && (turn?.id === Number(record.id))}
                                    size={'small'}
                                    style={{
                                        backgroundColor: (Number((record as any)?.valoreFinaleA ?? 0) > Number((record as any)?.inventarioA ?? 0)) ? 'red' : ''
                                    }}
                                    disabled={!record.dataOut}
                                    icon={<Icons.TabletOutlined />}
                                    danger={Number((record as any)?.valoreFinaleA ?? 0) > Number((record as any)?.inventarioA ?? 0)}
                                    onClick={() => showMovementA(record)}
                                >
                                </Button>
                            </Tooltip>
                            {/*<Tooltip placement="top" title={'Elenco Riassortimento Anticipato'}>*/}
                            {/*    <Button*/}
                            {/*        style={{*/}
                            {/*            color: (turn?.id === Number(record?.id) && exportDataRestock?.length > 0) ? 'red' : 'whitesmoke'*/}
                            {/*        }}*/}
                            {/*        loading={loadingR && (turn?.id === Number(record.id))}*/}
                            {/*        size={'small'}*/}
                            {/*        icon={<Icons.FileJpgOutlined />}*/}
                            {/*        onClick={() => showAlertRestock(record)}*/}
                            {/*    >*/}
                            {/*    </Button>*/}
                            {/*</Tooltip>*/}
                            <Tooltip placement="top" title={'Inventario'}>
                                <Button
                                    loading={loadingS && (turn?.id === Number(record.id))}
                                    size={'small'}
                                    disabled={!record.dataOut}
                                    icon={<Icons.FolderOutlined />}
                                    onClick={() => showSnapshotStock(record)}
                                >
                                </Button>
                            </Tooltip>
                            <Tooltip placement="top" title={'Documenti'}>
                                <Button
                                    loading={loadingS && (turn?.id === Number(record.id))}
                                    size={'small'}
                                    icon={<Icons.UploadOutlined />}
                                    onClick={() => showDocument(record)}
                                >
                                </Button>
                            </Tooltip>
                            <DeleteButton hidden={true}
                                hideText
                                size="small"
                                recordItemId={record.id}
                            />
                        </Space>
                    )}
                />
            </Table>
            <Modal {...modalAlertRestock} width={'60%'}
                   okText={'Chiudi'}
                   cancelText={'Annulla'}
                   onOk={closeModalAlertRestock}>
                <Table dataSource={exportDataRestock}
                       size={'small'}
                       sticky={false}
                       scroll={{y: window.innerHeight - 330 + 'px'}}
                       rowClassName={(record, index) => "red"}
                       pagination={false}>
                    <Table.Column
                        dataIndex={'turn'}
                        key={'turn'}
                        title={'User'}
                        render={(value) => (
                            value.user?.name + ' ' + value.user?.surname
                        )}
                    />
                    <Table.Column
                        dataIndex={'stock'}
                        key={'stock'}
                        title={'Articolo'}
                        render={(value) => (
                            value.product?.codice
                        )}
                    />
                    <Table.Column
                        dataIndex={'stock'}
                        key={'stock.description'}
                        title={'Descrizione'}
                        render={(value) => (
                            value.product?.description
                        )}
                    />
                    <Table.Column
                        dataIndex={'position'}
                        key={'position'}
                        title={'Posizione'}
                        render={(value) => (
                            <TagField value={value} style={{ color: 'red'}}/>
                        )}
                    />
                    <Table.Column
                        dataIndex={'description'}
                        key={'description'}
                        title={'Motivo'}
                        render={(value) => (
                            value
                        )}
                    />
                    <Table.Column
                        dataIndex={'note'}
                        key={'note'}
                        title={'Note'}
                        render={(value) => (
                            value
                        )}
                    />
                    <Table.Column
                        dataIndex={'createdAt'}
                        key={'createdAt'}
                        title={'Data'}
                        render={(value) => (
                            <DateField value={value} format={'DD-MM-YYYY - HH:mm:ss'} />
                        )}
                    />
                </Table>
            </Modal>
            <Modal {...modalModalSnapshotStock} width={'60%'}
                   okText={'Chiudi'}
                   cancelText={'Annulla'}
                   onOk={closeModalSnapshotStock}>
                <Table dataSource={turn?.snapshotStock?.priceCategoryEspositore}
                       title={data => (<Title level={5}>Ultimo Inventario Espositore</Title> )}
                       size={'small'}
                       rowKey="id"
                       sticky={false}
                       pagination={false}>
                    <Table.Column
                        dataIndex={'category'}
                        key={Math.random()}
                        title={'Categoria'}
                        render={(value) => (
                            value
                        )}
                    />
                    <Table.Column
                        dataIndex={'qta'}
                        key={'qta'}
                        title={'Qta'}
                        render={(value) => (
                            value
                        )}
                    />
                    <Table.Column
                        dataIndex={'tot'}
                        key={'tot'}
                        title={'Totale'}
                        render={(value) => (
                            '€ ' + parseFloat(value).toLocaleString('de', {
                                minimumFractionDigits: 2
                            })
                        )}
                    />
                </Table>
                <Table dataSource={turn?.snapshotStock?.priceCategoryMagazzino}
                       title={data => (<Title level={5}>Magazzino</Title> )}
                       size={'small'}
                       sticky={false}
                       rowKey="id"
                       pagination={false}>
                    <Table.Column
                        dataIndex={'category'}
                        key={'category'}
                        title={'Categoria'}
                        render={(value) => (
                            value
                        )}
                    />
                    <Table.Column
                        dataIndex={'qta'}
                        key={'qta'}
                        title={'Qta'}
                        render={(value) => (
                            value
                        )}
                    />
                    <Table.Column
                        dataIndex={'qtaP'}
                        key={'qtaP'}
                        title={'Qta P'}
                        render={(value) => (
                            value
                        )}
                    />
                    <Table.Column
                        dataIndex={'tot'}
                        key={'tot'}
                        title={'Totale'}
                        render={(value) => (
                            '€ ' + parseFloat(value).toLocaleString('de', {
                                minimumFractionDigits: 2
                            })
                        )}
                    />
                </Table>
            </Modal>
            <Modal {...modalModalDocument} width={'60%'}
                   okText={'Chiudi'}
                   cancelText={'Annulla'}
                   onOk={closeModalDocument}>
                <br />
                <hr />
                <Row gutter={24}>
                    <Col span={24}>
                        <Dragger {...props}
                                 showUploadList={false}
                                 style={{
                                     background: '#e8e268',
                                     border: 'none'
                                 }}
                                 multiple={false}
                        >
                            {/*<p className="ant-upload-text">Click or drag file to this area to upload</p>*/}
                            <p className="ant-upload-hint" style={{fontSize: 14, color: 'black'}}>
                                Upload Documenti!
                            </p>
                        </Dragger>
                    </Col>
                </Row>
                <hr />
                <Row gutter={24}>
                    <Col span={24}>
                        <Table dataSource={getDocumenti.data?.data}
                               size={'small'}
                               sticky={false}
                               pagination={false}>
                            <Table.Column
                                dataIndex={'description'}
                                key={'description'}
                                title={'Descrizione'}
                            />
                            <Table.Column
                                dataIndex={'createdAt'}
                                key={'createdAt'}
                                title={'Data'}
                                render={(value) => (
                                    <DateField value={value} format={'DD-MM-YYYY HH:mm'} />
                                )}
                            />
                            <Table.Column
                                dataIndex={'file'}
                                key={'file'}
                                title={'File'}
                                render={(value) => {
                                    // console.log(value)
                                    return (<Button type={'link'} size={'large'} icon={<Icons.DownloadOutlined />} href={API_URL + value.url} target={'_blank'} />)
                                }}
                            />
                        </Table>
                    </Col>
                </Row>
            </Modal>
            <Modal {...modalModalDocumentT} width={'60%'}
                   okText={'Chiudi'}
                   cancelText={'Annulla'}
                   onOk={closeModalDocumentT}>
                <br />
                <Title level={5}>Giacenza Espositore Tabacchi</Title>
                <br />
                <br />
                <Row gutter={[24, 24]} align="middle">
                    <Col>
                        <Statistic
                            title="Data Chiusura Turno"
                            valueRender={() => (
                                <DateField style={{fontSize: 25}} value={turn?.dataOut} format="DD-MM-YYYY HH:mm" />
                            )}
                        />
                    </Col>
                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Giacenza Iniziale"
                            value={parseFloat((turn?.giacenzaT ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Riassortimento"
                            value={turn && turn?.valoreRiassortimentoT ? parseFloat((turn?.valoreRiassortimentoT ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 }) : 0}
                            precision={2}
                            prefix="€"
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Venduto"
                            value={turn && turn.dati && turn?.dati?.in && turn?.dati?.in?.acs ? parseFloat(turn?.dati?.in?.tabacchi.toString()).toLocaleString('de', { minimumFractionDigits: 2 }) : 0}
                            precision={2}
                            prefix="€"
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Giacenza Finale"
                            value={parseFloat((turn?.valoreFinaleT ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>
                    <Col>
                        <Statistic
                            title="Inventario"
                            value={parseFloat((turn?.inventarioT ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>
                    <Col hidden={!turn?.isInventario}>
                        <Statistic
                            title="Giacenza Finale Conto"
                            value={parseFloat((turn?.giacenzaT ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>
                    <Col>
                        <Statistic
                            title="Verifica"
                            value={(() => {
                                const inventario = Number(turn?.inventarioT ?? 0);
                                const giacenza = Number(turn?.giacenzaT ?? 0);
                                const diff = inventario - giacenza;

                                const stato = diff >= 0 ? "REGOLARE" : "ALERT";
                                const diffFormatted = diff.toLocaleString("de", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                });
                                const sign = diff >= 0 ? "+" : "";
                                return `${stato} (${sign}${diffFormatted})`;
                            })()}
                            valueStyle={{
                                color:
                                    (() => {
                                        const inventario = Number(turn?.inventarioT ?? 0);
                                        const giacenza = Number(turn?.giacenzaT ?? 0);
                                        const diff = inventario - giacenza;
                                        return diff >= 0 ? "#52c41a" : "#cf1322"; // verde / rosso
                                    })(),
                                fontWeight: 600,
                            }}
                        />
                    </Col>
                </Row>
                <br />
                <br />
            </Modal>
            <Modal {...modalModalDocumentG} width={'60%'}
                   okText={'Chiudi'}
                   cancelText={'Annulla'}
                   onOk={closeModalDocumentG}>
                <br />
                <Title level={5}>Giacenza Espositore G&V</Title>
                <br />
                <br />
                <Row gutter={[24, 24]} align="middle">
                    <Col>
                        <Statistic
                            title="Data Chiusura Turno"
                            valueRender={() => (
                                <DateField style={{fontSize: 25}} value={turn?.dataOut} format="DD-MM-YYYY HH:mm" />
                            )}
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Giacenza Iniziale"
                            value={parseFloat((turn?.giacenzaG ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Riassortimento"
                            value={turn && turn?.valoreRiassortimentoG ? parseFloat((turn?.valoreRiassortimentoG ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 }) : 0}
                            precision={2}
                            prefix="€"
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Venduto"
                            value={turn && turn.dati && turn?.dati?.in && turn?.dati?.in?.acs ? parseFloat(turn?.dati?.in?.gev.toString()).toLocaleString('de', { minimumFractionDigits: 2 }) : 0}
                            precision={2}
                            prefix="€"
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Giacenza Finale"
                            value={parseFloat((turn?.valoreFinaleG ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>
                    <Col>
                        <Statistic
                            title="Inventario"
                            value={parseFloat((turn?.inventarioG ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>
                    <Col hidden={!turn?.isInventario}>
                        <Statistic
                            title="Giacenza Finale Conto"
                            value={parseFloat((turn?.giacenzaG ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>
                    <Col>
                        <Statistic
                            title="Verifica"
                            value={(() => {
                                const inventario = Number(turn?.inventarioG ?? 0);
                                const giacenza = Number(turn?.giacenzaG ?? 0);
                                const diff = inventario - giacenza;

                                const stato = diff >= 0 ? "REGOLARE" : "ALERT";
                                const diffFormatted = diff.toLocaleString("de", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                });
                                const sign = diff >= 0 ? "+" : "";
                                return `${stato} (${sign}${diffFormatted})`;
                            })()}
                            valueStyle={{
                                color:
                                    (() => {
                                        const inventario = Number(turn?.inventarioG ?? 0);
                                        const giacenza = Number(turn?.giacenzaG ?? 0);
                                        const diff = inventario - giacenza;
                                        return diff >= 0 ? "#52c41a" : "#cf1322"; // verde / rosso
                                    })(),
                                fontWeight: 600,
                            }}
                        />
                    </Col>
                </Row>
                <br />
                <br />
            </Modal>
            <Modal {...modalModalDocumentA} width={'60%'}
                   okText={'Chiudi'}
                   cancelText={'Annulla'}
                   onOk={closeModalDocumentA}>
                <br />
                <Title level={5}>Giacenza Espositore Accessori</Title>
                <br />
                <br />
                <Row gutter={[24, 24]} align="middle">
                    <Col>
                        <Statistic
                            title="Data Chiusura Turno"
                            valueRender={() => (
                                <DateField style={{fontSize: 25}} value={turn?.dataOut} format="DD-MM-YYYY HH:mm" />
                            )}
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Giacenza Iniziale"
                            value={parseFloat((turn?.giacenzaA ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Riassortimento"
                            value={turn && turn?.valoreRiassortimentoA ? parseFloat((turn?.valoreRiassortimentoA ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 }) : 0}
                            precision={2}
                            prefix="€"
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Venduto"
                            value={turn && turn.dati && turn?.dati?.in && turn?.dati?.in?.acs ? parseFloat(turn?.dati?.in?.acs.toString()).toLocaleString('de', { minimumFractionDigits: 2 }) : 0}
                            precision={2}
                            prefix="€"
                        />
                    </Col>

                    <Col hidden={turn?.isInventario}>
                        <Statistic
                            title="Giacenza Finale"
                            value={parseFloat((turn?.valoreFinaleA ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>
                    <Col>
                        <Statistic
                            title="Inventario"
                            value={parseFloat((turn?.inventarioA ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>
                    <Col hidden={!turn?.isInventario}>
                        <Statistic
                            title="Giacenza Finale Conto"
                            value={parseFloat((turn?.giacenzaA ?? 0).toString()).toLocaleString('de', { minimumFractionDigits: 2 })}
                            precision={2}
                            prefix="€"
                        />
                    </Col>
                    <Col>
                        <Statistic
                            title="Verifica"
                            value={(() => {
                                const inventario = Number(turn?.inventarioA ?? 0);
                                const giacenza = Number(turn?.giacenzaA ?? 0);
                                const diff = inventario - giacenza;

                                const stato = diff >= 0 ? "REGOLARE" : "ALERT";
                                const diffFormatted = diff.toLocaleString("de", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                });

                                const sign = diff >= 0 ? "+" : "";
                                return `${stato} (${sign}${diffFormatted})`;
                            })()}
                            valueStyle={{
                                color:
                                    (() => {
                                        const inventario = Number(turn?.inventarioA ?? 0);
                                        const giacenza = Number(turn?.giacenzaA ?? 0);
                                        const diff = inventario - giacenza;
                                        return diff >= 0 ? "#52c41a" : "#cf1322"; // verde / rosso
                                    })(),
                                fontWeight: 600,
                            }}
                        />
                    </Col>
                </Row>
                <br />
                <br />
            </Modal>
            <Modal {...modalProps} width={900} cancelText={'Annulla'} okText={'Conferma'}
                   footer={
                <>
                    <Space>
                        <Button icon={<Icons.ExportOutlined  />} htmlType={'button'} onClick={() => exportTurn()}>Stampa Turno</Button>
                        <Button danger={true} type="primary" onClick={close}>
                            {turn?.isConfirmed ? 'Chiudi' : 'Annulla'}
                        </Button>
                        <Popconfirm
                            title="Attenzione"
                            open={openConfirm}
                            description="Sei Sicuro di voler confermare i dati inseriti?
                        Una volta confermato non potrai più modificare i dati!"
                            onConfirm={conferma}
                            cancelText={'No'}
                            okText={'Si! Sono Sicuro'}
                            onCancel={handleCancel}
                        >
                            <Button type="primary" onClick={onCheck} hidden={turn?.isConfirmed}>
                                Conferma
                            </Button>
                        </Popconfirm>
                    </Space>
                </>

            }
            >
                <Space direction="vertical"  style={{ width: '100%' }}>
                <Spin spinning={loading} tip="Loading" size={'large'} >
                    <Title level={4}>Utente: {turn?.user?.name} - Apertura: { dayjs(turn?.dataIn).format('DD-MM-YYYY HH:mm')} - Chiusura: { dayjs(turn?.dataOut).format('DD-MM-YYYY HH:mm')} </Title>
                    <Title level={5} style={{ color: 'red'}}>
                        {(exportDataRestock && exportDataRestock?.length > 0) ? ' --- ' : ''}
                        {(exportDataRestock && exportDataRestock?.length > 0) ? 'Sono Presenti Alert Riassortimento' : ''}
                    </Title>
                    <Divider />

                        <Row gutter={24}>
                            <Col span={12}>
                                <Title level={4} >Entrate</Title>
                            </Col>
                            <Col span={12}>
                                <Title level={4} >Importo</Title>
                            </Col>
                        </Row>
                        <Divider />
                    <Row gutter={24}>
                        <Col span={8}>
                            Tabacchi
                        </Col>
                        <Col span={16}>
                            <InputNumber
                                onInput={onChangeTabacchi}
                                precision={2}
                                controls={false}
                                readOnly={turn?.isConfirmed}
                                style={{width: '100%', appearance: 'textfield', backgroundColor: 0 % 2 ? '#222222' : ''}}
                                decimalSeparator = {','}
                                value={turn?.dati?.in?.tabacchi}
                            />
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={8}>
                            Gratta & Vinci
                        </Col>
                        <Col span={16}>
                            <InputNumber
                                onInput={onChangeGratta}
                                precision={2}
                                controls={false}
                                readOnly={turn?.isConfirmed}
                                style={{width: '100%', appearance: 'textfield', backgroundColor: 1 % 2 ? '#222222' : ''}}
                                decimalSeparator = {','}
                                value={turn?.dati?.in?.gev}
                            />
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={8}>
                            Accessori
                        </Col>
                        <Col span={16}>
                            <InputNumber
                                onInput={onChangeAccessori}
                                precision={2}
                                controls={false}
                                readOnly={turn?.isConfirmed}
                                style={{width: '100%', appearance: 'textfield', backgroundColor: 2 % 2 ? '#222222' : ''}}
                                decimalSeparator = {','}
                                value={turn?.dati?.in?.acs}
                            />
                        </Col>
                    </Row>
                        <Row gutter={24}>
                            <Col span={8}>
                                Scontrinato
                            </Col>
                            <Col span={16}>
                                <InputNumber
                                    precision={2}
                                    controls={false}
                                    readOnly={turn?.isConfirmed}
                                    decimalSeparator = {','}
                                    style={{width: '100%', appearance: 'textfield', backgroundColor: '#222222'}}
                                    onInput={onChangeScontrinato}
                                    value={turn?.dati?.in?.scontrinato}
                                    // formatter={(scontrinato) => `${parseFloat(Number(scontrinato).toString()).toFixed(2)}`.replace(/\$\s?|(\.)/g, ',')}
                                    // parser={(scontrinato) => parseFloat(Number(scontrinato).toString()).toFixed(2).replace('.', '').replace(/,/g, '.')}
                                />
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={8}>
                                Scontrinato 22%
                            </Col>
                            <Col span={16}>
                                <InputNumber
                                    precision={2}
                                    controls={false}
                                    readOnly={turn?.isConfirmed}
                                    style={{width: '100%', appearance: 'textfield'}}
                                    decimalSeparator = {','}
                                    onInput={onChangeScontrinato22}
                                    value={turn?.dati?.in?.scontrinato22}
                                    // formatter={(scontrinato22) => `${parseFloat(Number(scontrinato22).toString()).toFixed(2)}`.replace(/\$\s?|(\.)/g, ',')}
                                    // parser={(scontrinato22) => parseFloat(Number(scontrinato22).toString()).toFixed(2).replace('.', '').replace(/,/g, '.')}
                                />
                            </Col>
                        </Row>
                    <Form form={entrate}>
                        { causali && causali.map( (x: any, i: any) =>
                          x.isLoad && x.isTurn &&
                            <Row gutter={24}>
                                <Col span={8}>
                                    {x.description}
                                </Col>
                                <Col span={16}>
                                        <Form.Item
                                            style={{marginBottom:  0}}
                                            name={x.acronimo}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Campo Obbligatorio'
                                                },
                                            ]}
                                        >
                                            <InputNumber
                                                controls={false}
                                                readOnly={turn?.isConfirmed}
                                                style={{width: '100%', appearance: 'textfield', backgroundColor: i % 2 ? '' : '#222222'}}
                                                precision={2}
                                                decimalSeparator= {','}
                                                onChange={(e) => onChangeEntrate(e, x.acronimo)}
                                                // formatter={(value) => `${parseFloat(Number(value).toString()).toFixed(2)}`.replace(/\$\s?|(\.)/g, '.')}
                                                // parser={(value) => parseFloat(Number(value).toString()).toFixed(2).replace('.', '').replace(/,/g, '.')}
                                            />
                                        </Form.Item>
                                </Col>
                            </Row>
                        )}
                    </Form>
                        <Row gutter={24}>
                            <Col span={12}>
                                <Title level={3} >Importo Entrate</Title>
                            </Col>
                            <Col span={12}>
                                <Title level={3} >{Number(parseFloat(importoEntrate).toFixed(2)).toLocaleString('de', {
                                    minimumFractionDigits: 2
                                })} €</Title>
                            </Col>
                        </Row>
                        <Divider />
                        <Row gutter={24}>
                            <Col span={12}>
                                <Title level={4} >Uscite</Title>
                            </Col>
                            <Col span={12}>
                                <Title level={4} >Importo</Title>
                            </Col>
                        </Row>
                        <Divider />
                    <Form form={uscite}>
                        { causali && causali.map( (x: any, i: any) =>
                            x.isUnLoad && x.isTurn &&
                            <Row gutter={24}>
                                <Col span={8}>
                                    {x.description}
                                </Col>
                                <Col span={16}>
                                    <Form.Item
                                        style={{marginBottom:  0}}
                                        name={x.acronimo}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Campo Obbligatorio'
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            controls={false}
                                            readOnly={turn?.isConfirmed}
                                            style={{width: '100%', appearance: 'textfield', backgroundColor: i % 2 ? '#222222' : ''}}
                                            precision={2}
                                            decimalSeparator= {','}
                                            onChange={(e) => onChangeUscite(e, x.acronimo)}
                                            // formatter={(value) => `${parseFloat(Number(value).toString()).toFixed(2)}`.replace(/\$\s?|(\.)/g, '.')}
                                            // parser={(value) => parseFloat(Number(value).toString()).toFixed(2).replace('.', '').replace(/,/g, '.')}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                    </Form>
                        <Row gutter={24}>
                            <Col span={12}>
                                <Title level={3} >Importo Uscite</Title>
                            </Col>
                            <Col span={12}>
                                <Title level={3} >{Number(importoUscite.toFixed(2)).toLocaleString('de', {
                                    minimumFractionDigits: 2
                                })} €</Title>
                            </Col>
                        </Row>
                        <Divider />
                        <Row gutter={24}>
                            <Col span={8}>
                                Incasso Contabile
                            </Col>
                            <Col span={16}>
                                <InputNumber readOnly={true}
                                             precision={2}
                                             controls={false}
                                             style={{width: '100%', appearance: 'textfield', backgroundColor: '#222222'}}
                                             decimalSeparator = {','}
                                             value={(parseFloat(importoEntrate) - importoUscite).toFixed(2)}
                                             formatter={(taba) => `${parseFloat(Number(taba).toString()).toFixed(2)}`.replace(/\$\s?|(\.)/g, ',')}
                                    // parser={(tabacchi) => parseFloat(Number(tabacchi).toString()).toFixed(2).replace('.', '').replace(/,/g, '.')}
                                />
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={8}>
                                Incasso Reale
                            </Col>
                            <Col span={16}>
                                <InputNumber
                                    name={'incassoReale'}
                                    style={{width: '100%', appearance: 'textfield'}}
                                    controls={false}
                                    precision={2}
                                    decimalSeparator = {','}
                                    readOnly={turn?.isConfirmed}
                                    onInput={onChangeIncassoReale}
                                    value={turn?.dati?.incassoReale}
                                    // formatter={(value) => `${parseFloat(Number(value).toString()).toFixed(2)}`.replace(/\$\s?|(\.)/g, '.')}
                                    // parser={(value) => parseFloat(Number(value).toString()).toFixed(2).replace('.', '').replace(/,/g, '.')}
                                />
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                                <Title level={3} >Differenza</Title>
                            </Col>
                            <Col span={12}>
                                <Title level={3} >{
                                    Number(incassoReale - (importoEntrate - importoUscite)).toFixed(2)
                                } €</Title>
                            </Col>
                        </Row>

                </Spin>
                </Space>
            </Modal>
        </List>
    );
};
